import { trackUser } from '~/analytics';
import type { AuthUser } from '~/auth/user';
import type { QuickNavCloseReason, QuickNavOpenSource, QuickNavSectionId } from './types';

export function trackQuickNavOpen(user: AuthUser, source: QuickNavOpenSource) {
    trackUser('quick_nav_open', user, { source });
}

export function trackQuickNavClose(user: AuthUser, reason: QuickNavCloseReason) {
    trackUser('quick_nav_close', user, { reason });
}

export function trackQuickNavSelect(
    user: AuthUser,
    data: {
        path: string;
        title?: string;
        section: QuickNavSectionId;
        query?: string;
    },
) {
    trackUser('quick_nav_select', user, data);
}

export function trackQuickNavNoResults(user: AuthUser, query?: string) {
    trackUser('quick_nav_no_results', user, query ? { query } : {});
}
